import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { getAuthenticatedDashboardPath } from '../utils/appSession';
import { MARKETING_SITE_URL } from '../utils/siteHost';

const AppRootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const dashboardPath = getAuthenticatedDashboardPath();
    if (dashboardPath) {
      navigate(dashboardPath, { replace: true });
      return;
    }
    window.location.replace(MARKETING_SITE_URL);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-400 text-sm">
      <Loader2 className="h-5 w-5 animate-spin mr-2" />
      Preusmeravanje...
    </div>
  );
};

export default AppRootRedirect;
